export * from "@/ui/components/sections/marketing/social-proof/Testimonial/Testimonial";
export * from "@/ui/components/sections/marketing/social-proof/Testimonial/Testimonial.config";
